import React, { useEffect, useState } from 'react';
import { MultipleQuestionnairesBlock } from '@coog/react-components';
import PropTypes from 'prop-types';
import { forEach, get, isEqual, map, omit, reduce } from 'lodash-es';
import Action from './Action.presentational';

const QuotationPresentational = ({
  blockQuotation,
  isFinishedSalesRoute,
  partialUpdateSalesRouteQuotations,
  strings,
  cancelSalesRoute,
  putOnHoldSalesRoute,
  editField,
  willResetForm,
  onResetForm,
  willSaveForm,
  onSaveForm,
  noSaveNotValid,
  i18n,
}) => {
  const [isValidBlock, setIsValidBlock] = useState(false);
  const [answersBlock, setAnswersBlock] = useState();
  let saveAnswersState = {};

  const handleChangeIsValidBlock = (isValidLocal, id) => {
    let tmpIsValid;

    if (isValidLocal === null && id != null) {
      tmpIsValid = omit(isValidBlock, id);
    } else {
      tmpIsValid = { ...isValidBlock, ...isValidLocal };
    }

    if (!isEqual(tmpIsValid, isValidBlock)) {
      setIsValidBlock(tmpIsValid);
    }
  };

  const handleChangeAnswersBlock = (answersLocal, id) => {
    let tmpAnswers;
    let answersState = answersBlock;

    if (answersLocal === null && id != null) {
      tmpAnswers = omit(answersBlock, id);
    } else {
      if (!answersBlock || (answersBlock && Object.keys(saveAnswersState).length > Object.keys(answersBlock).length)) {
        answersState = saveAnswersState;
      }

      tmpAnswers = { ...answersState, ...answersLocal };
    }

    if (!isEqual(tmpAnswers, answersBlock)) {
      saveAnswersState = tmpAnswers;
      setAnswersBlock(tmpAnswers);
    }
  };

  const handleEditField = (answersLocal, id) => {
    if (answersBlock) {
      if (answersLocal === null && id != null) {
        editField();
      } else {
        const tmpAnswers = { ...answersBlock, ...answersLocal };

        if (!isEqual(tmpAnswers, answersBlock)) {
          editField();
        }
      }
    }
  };

  const onResetFormLocal = data => {
    const answersReset = {};
    const isValidReset = {};
    forEach(
      map(data, l => l.id),
      id => {
        if (answersBlock[id]) {
          answersReset[id] = answersBlock[id];
        }
        if (isValidBlock[id]) {
          isValidReset[id] = isValidBlock[id];
        }
      }
    );
    setAnswersBlock(answersReset);
    setIsValidBlock(isValidReset);

    onResetForm();
  };

  const checkIsValid = reduce(isValidBlock, (acc, isValid) => acc && isValid, true);

  /**
   * check disable next button
   */
  const checkDisableNextButton = () => {
    let disableNextButton;
    if (isFinishedSalesRoute) {
      disableNextButton = true;
    } else {
      disableNextButton = !checkIsValid;
    }
    return disableNextButton;
  };

  useEffect(() => {
    if (willSaveForm) {
      if (checkIsValid) {
        partialUpdateSalesRouteQuotations({ answers: answersBlock, saveOnly: true })();
        onSaveForm();
      } else {
        noSaveNotValid();
      }
    }
  }, [willSaveForm]);

  // label Button
  const labelNextButton = get(strings, 'editsalesroute.action.button.nextstep.label', 'Etape Suivante');
  const labelCancelButton = get(strings, 'editsalesroute.action.button.cancel.label', 'Annuler');
  const labelPutonholdButton = get(strings, 'editsalesroute.action.button.putonhold.label', 'Mettre en attente');

  return (
    <>
      <MultipleQuestionnairesBlock
        blockData={blockQuotation}
        blockType="quotations"
        eventEmitter={event => {
          handleChangeIsValidBlock(get(event, 'isValid'), get(event, 'id'));
          handleChangeAnswersBlock(get(event, 'answers'), get(event, 'id'));
          handleEditField(get(event, 'answers'), get(event, 'id'));
        }}
        strings={strings}
        willResetForm={willResetForm}
        onResetForm={onResetFormLocal}
        i18n={i18n}
      />
      <Action
        isDisabledNextButton={checkDisableNextButton()}
        partialUpdateSalesRoute={partialUpdateSalesRouteQuotations({ answers: answersBlock })}
        cancelSalesRoute={cancelSalesRoute}
        putOnHoldSalesRoute={putOnHoldSalesRoute}
        labelNextButton={labelNextButton}
        labelCancelButton={labelCancelButton}
        labelPutonholdButton={labelPutonholdButton}
      />
    </>
  );
};

QuotationPresentational.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  blockQuotation: PropTypes.object.isRequired,
  isFinishedSalesRoute: PropTypes.bool, // eslint-disable-line
  partialUpdateSalesRouteQuotations: PropTypes.func.isRequired,
  cancelSalesRoute: PropTypes.func.isRequired,
  putOnHoldSalesRoute: PropTypes.func.isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  editField: PropTypes.func.isRequired,
  willResetForm: PropTypes.bool,
  onResetForm: PropTypes.func,
  willSaveForm: PropTypes.bool,
  onSaveForm: PropTypes.func,
  noSaveNotValid: PropTypes.func,
  i18n: PropTypes.object,
};

QuotationPresentational.defaultProps = {
  isFinishedSalesRoute: false,
  strings: {},
  willResetForm: false,
  onResetForm: () => {},
  willSaveForm: false,
  onSaveForm: () => {},
  noSaveNotValid: () => {},
  i18n: {},
};

export default QuotationPresentational;
